// extracted by mini-css-extract-plugin
export default {"main":"Cart_main__DJNp6","cartcard":"Cart_cartcard__K5ncm","imagediv":"Cart_imagediv__LypL6","image":"Cart_image__zo6F-","details":"Cart_details__kaV8z"};